// import { graphql, StaticQuery } from 'gatsby';
import RichTextWPViewer from '@components/RichTextWPViewer';
import VnrLink from '@components/VnrLink';
import { scrollToById } from '@utils/domHtmlUtil';
import { Modal } from 'antd';
import React, { useEffect } from 'react';

import styles from '../styles.module.scss';
// TODO_HUY
// import { getQueryParams } from "react-uikit/utils/urlUtil";
import BigPicturePost from './BigPicturePost';

const BigPictureNews = ({ post, data }) => {
  const [visible, setVisible] = React.useState(false);
  const [highLight, setHighLight] = React.useState(false);
  // TODO_HUY
  // const { bigPicture } = getQueryParams();
  const { bigPicture } = {};
  useEffect(() => {
    if (!bigPicture || bigPicture === '') {
      return;
    }
    if (post.wordpress_id === bigPicture) {
      scrollToById(post.wordpress_id, { detalY: -150 });
      setVisible(true);
      setHighLight(true);
      if (content === null || content === '') {
        setTimeout(() => {
          setHighLight(false);
        }, 3000);
      }
    }
  }, [bigPicture]);
  const showModal = () => {
    setVisible(true);
  };
  const handleClose = () => {
    setVisible(false);
    if (highLight) {
      setTimeout(() => {
        setHighLight(false);
      }, 3000);
    }
  };

  const author = null;
  // data.allWordpressWpUsers.nodes.find(
  //   (item) =>
  //     item.wordpress_id === post.relate_posts_author || 106
  // );
  // return <div>{author.acf.avatar.localFile.publicURL}</div>;
  const title = post.relate_posts_title || post.latest_posts_title;
  const content = post.relate_posts_quote || post.latest_posts_quote;
  const public_date = post.relate_posts_public_date;
  return (
    <div
      id={post.wordpress_id}
      className={styles[highLight ? 'vnr-big-picture-post-high-light' : '']}
    >
      <div className={styles[post.hidden ? 'post-hidden' : '']}>
        <BigPicturePost
          post={{ title: title, content: content, public_date: public_date, author: author }}
          showModal={showModal}
        />
      </div>
      {content ? (
        <Modal
          title={
            author && (
              <div className={styles['modal-card']}>
                <img
                  className={styles['img-author']}
                  src={author.acf.avatar.localFile.publicURL}
                  alt=""
                ></img>
                <div>
                  <div className={styles['author']}>{author.name}</div>
                  <div>{author.acf.profession}</div>
                </div>
              </div>
            )
          }
          visible={visible}
          onOk={handleClose}
          onCancel={handleClose}
          footer={
            author && (
              <div className={styles['']}>
                <span className={styles['modal-footer-author']}>
                  Tác giả{' '}
                  <VnrLink
                    to={`/tac-gia/${author.acf.author_path}`}
                    className={styles['author-name']}
                  >{` ${author.name}`}</VnrLink>
                </span>
                <span className={styles['modal-footer-date']}>{`| ${
                  post.relate_posts_public_date || post.latest_posts_public_date
                }`}</span>
              </div>
            )
          }
          className={styles['vnr-modal-BigPicture']}
        >
          <p className={styles['sentiment']}>
            <strong>{title}</strong>
          </p>
          <RichTextWPViewer content={content} />
        </Modal>
      ) : null}
    </div>
  );
};
export default BigPictureNews;
